import { render } from "./UserGroupDeleteConfirmationDialog.vue?vue&type=template&id=6f7b18f5"
import script from "./UserGroupDeleteConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./UserGroupDeleteConfirmationDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__